import type { ReactNode } from "react";
import FilterArticlesPage from "components/organisms/FilterArticlesPage";
import ApplicationRoles from "constants/ApplicationRoles";
import Statut from "constants/Statut";
import { useScrollToTop } from "hooks";

const AVAILABLE_STATUTS: Array<Statut> = [
  Statut.EN_PREPARATION,
  Statut.COMMANDE,
  Statut.EN_TRANSIT,
  Statut.PRET_EN_MAGASIN,
  Statut.LIVRE,
];

function StoreTriByArticlePage(): ReactNode {
  useScrollToTop();
  return (
    <FilterArticlesPage
      availableStatuts={AVAILABLE_STATUTS}
      roles={ApplicationRoles.STOREMANAGER}
      pageTitle="Tri par article"
    />
  );
}

export default StoreTriByArticlePage;
